(function armorDosingV2Bootstrap() {
  'use strict';

  var GLOBAL_KEY = 'ArmorDosingV2';
  var ROOT_SELECTOR = '[data-armor-dosing-v2][data-display-mode="full"]';

  if (
    window[GLOBAL_KEY] &&
    typeof window[GLOBAL_KEY].refresh === 'function'
  ) {
    window[GLOBAL_KEY].refresh(document);
    return;
  }

  var instances = new WeakMap();

  function normalize(value) {
    return String(value || '')
      .toLocaleLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function rootsWithin(container) {
    var roots = [];
    if (!container) return roots;
    if (container.matches && container.matches(ROOT_SELECTOR)) roots.push(container);
    if (container.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(container.querySelectorAll(ROOT_SELECTOR)));
    }
    return roots;
  }

  function initialize(root) {
    if (!root || instances.has(root)) return;

    var controls = root.querySelector('[data-dosing-controls]');
    var search = root.querySelector('[data-dosing-search]');
    var clear = root.querySelector('[data-dosing-clear]');
    var filters = root.querySelector('[data-dosing-filters]');
    var count = root.querySelector('[data-dosing-count]');
    var empty = root.querySelector('[data-dosing-empty]');
    var table = root.querySelector('[data-dosing-table]');
    var outcome = root.querySelector('[data-dosing-search-outcome]');
    var exactSummary = root.querySelector('[data-dosing-exact-summary]');
    var modelSummary = root.querySelector('[data-dosing-model-summary]');
    var compactResults = root.querySelector('[data-dosing-compact-results]');
    var exactRegion = root.querySelector('[data-dosing-exact-region]');
    var exactDisclosure = root.querySelector('[data-dosing-exact-disclosure]');
    var directory = root.querySelector('[data-dose-directory]');
    var searchGuidance = root.querySelector('[data-dosing-search-guidance]');
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-armor-dosing-row]'));

    if (
      !controls ||
      !search ||
      !clear ||
      !filters ||
      !count ||
      !empty ||
      !table ||
      !outcome ||
      !exactSummary ||
      !modelSummary ||
      !compactResults ||
      !exactRegion ||
      !exactDisclosure ||
      !directory ||
      !searchGuidance ||
      !rows.length
    ) {
      return;
    }

    var controller = new AbortController();
    var signal = controller.signal;
    var activeDevice = 'all';
    var timer = null;
    var visibleExactCount = rows.length;
    var visibleModelCount = directory.querySelectorAll('[data-dose-model]').length;

    rows.forEach(function prepareRow(row) {
      row.dataset.filterText = normalize([
        row.dataset.device,
        row.dataset.model,
        row.dataset.tire
      ].join(' '));
    });

    function syncFilterButtons() {
      filters.querySelectorAll('[data-dosing-device]').forEach(function sync(button) {
        var isActive = button.dataset.dosingDevice === activeDevice;
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function appendText(parent, tagName, className, text) {
      var node = document.createElement(tagName);
      if (className) node.className = className;
      node.textContent = text;
      parent.appendChild(node);
      return node;
    }

    function exactFinderUrl(row) {
      var device =
        row.dataset.device === 'Onewheel / single-wheel board' ? 'onewheel' : 'scooter';
      return (
        '/pages/find-my-formula?device=' +
        encodeURIComponent(device) +
        '&row=' +
        encodeURIComponent(row.dataset.rowId) +
        '&mode=exact'
      );
    }

    function renderCompactResults(query, visibleRows) {
      compactResults.textContent = '';
      compactResults.hidden =
        (!query && activeDevice === 'all') ||
        visibleRows.length === 0 ||
        visibleRows.length > 12;
      if (compactResults.hidden) return;

      visibleRows.forEach(function renderRow(row) {
        var card = document.createElement('article');
        card.className = 'armor-dosing-v2__compact-card';
        appendText(card, 'p', 'armor-dosing-v2__compact-kicker', row.dataset.device);
        appendText(card, 'h3', '', row.dataset.model);
        appendText(
          card,
          'p',
          'armor-dosing-v2__compact-amount',
          'About ' + row.querySelector('[data-dose-value]').textContent.trim().replace(/\s*oz$/i, '') +
            ' US fl oz per tire'
        );
        appendText(card, 'p', '', row.dataset.tire);
        var action = appendText(
          card,
          'a',
          'armor-dosing-v2__compact-action',
          'Choose my formula and bottle'
        );
        action.href = exactFinderUrl(row);
        appendText(
          card,
          'p',
          'armor-dosing-v2__compact-check',
          'Use this estimate for one empty tire, with Red, Blue or Green.'
        );
        compactResults.appendChild(card);
      });
    }

    function syncOutcome(query) {
      var hasSelection = Boolean(query) || activeDevice !== 'all';
      var totalMatches = visibleExactCount + visibleModelCount;
      exactSummary.textContent =
        visibleExactCount + (visibleExactCount === 1 ? ' fill amount' : ' fill amounts');
      modelSummary.textContent =
        visibleModelCount > 0 && query
          ? visibleModelCount +
            (visibleModelCount === 1 ? ' model with tire details' : ' models with tire details')
          : visibleModelCount + ' models with tire details';
      exactSummary.parentElement.hidden = hasSelection && visibleExactCount === 0;
      modelSummary.parentElement.hidden = hasSelection && visibleModelCount === 0;
      outcome.hidden = !hasSelection || totalMatches === 0;
      outcome.dataset.hasQuery = query ? 'true' : 'false';
      outcome.dataset.outcome =
        visibleExactCount > 0
          ? 'exact'
          : visibleModelCount > 0
            ? 'measurement'
            : 'empty';
      empty.hidden = totalMatches !== 0;
    }

    function applyFilters() {
      var query = normalize(search.value);
      var terms = query ? query.split(' ') : [];
      var visibleCount = 0;
      var visibleRows = [];

      rows.forEach(function filterRow(row) {
        var matchesDevice = activeDevice === 'all' || row.dataset.device === activeDevice;
        var haystack = row.dataset.filterText || '';
        var matchesQuery = terms.every(function matchTerm(term) {
          return haystack.replace(/[^a-z0-9]/g, '').indexOf(term.replace(/[^a-z0-9]/g, '')) !== -1;
        });
        var isVisible = matchesDevice && matchesQuery;
        row.hidden = !isVisible;
        if (isVisible) {
          visibleCount += 1;
          visibleRows.push(row);
        }
      });

      visibleExactCount = visibleCount;

      root.classList.toggle('has-active-dosing-search', Boolean(query) || activeDevice !== 'all');
      clear.hidden = !query;
      table.hidden = false;
      exactRegion.hidden = visibleCount === 0;
      exactDisclosure.querySelector('summary').textContent =
        query || activeDevice !== 'all'
          ? 'View matching tires'
          : 'View all fill amounts';
      count.textContent =
        (count.dataset.countTemplate || '[count] tire setups').replace('[count]', String(visibleCount));
      renderCompactResults(query, visibleRows);
      syncOutcome(query);
    }

    function scheduleFilters() {
      window.clearTimeout(timer);
      timer = window.setTimeout(applyFilters, 80);
    }

    function handleFilterClick(event) {
      var button = event.target.closest('[data-dosing-device]');
      if (!button || !filters.contains(button)) return;
      activeDevice = button.dataset.dosingDevice || 'all';
      syncFilterButtons();
      applyFilters();
    }

    function clearSearch() {
      search.value = '';
      applyFilters();
      search.focus();
    }

    search.addEventListener('input', scheduleFilters, { signal: signal });
    clear.addEventListener('click', clearSearch, { signal: signal });
    filters.addEventListener('click', handleFilterClick, { signal: signal });
    root.addEventListener(
      'armor:dosing-directory-updated',
      function syncDirectoryCount(event) {
        visibleModelCount = Number(event.detail && event.detail.count) || 0;
        syncOutcome(normalize(search.value));
      },
      { signal: signal }
    );

    controls.hidden = false;
    root.classList.add('is-enhanced');
    exactDisclosure.open = false;
    syncFilterButtons();
    applyFilters();

    instances.set(root, {
      destroy: function destroy() {
        controller.abort();
        window.clearTimeout(timer);
        rows.forEach(function restoreRow(row) {
          row.hidden = false;
          delete row.dataset.filterText;
        });
        search.value = '';
        activeDevice = 'all';
        controls.hidden = true;
        table.hidden = false;
        exactDisclosure.hidden = false;
        exactRegion.hidden = false;
        exactDisclosure.open = true;
        controls.parentNode.insertBefore(searchGuidance, controls.nextSibling);
        empty.hidden = true;
        outcome.hidden = true;
        exactSummary.parentElement.hidden = false;
        modelSummary.parentElement.hidden = false;
        outcome.removeAttribute('data-outcome');
        compactResults.hidden = true;
        compactResults.textContent = '';
        root.classList.remove('has-active-dosing-search');
        count.textContent = (count.dataset.countTemplate || '[count] tire setups').replace('[count]', String(rows.length));
        root.classList.remove('is-enhanced');
        instances.delete(root);
      }
    });
  }

  function refresh(container) {
    rootsWithin(container).forEach(initialize);
  }

  function destroy(container) {
    rootsWithin(container).forEach(function destroyRoot(root) {
      var instance = instances.get(root);
      if (instance) instance.destroy();
    });
  }

  window[GLOBAL_KEY] = {
    refresh: refresh,
    destroy: destroy
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function initializeDocument() {
        refresh(document);
      },
      { once: true }
    );
  } else {
    refresh(document);
  }

  document.addEventListener('shopify:section:load', function initializeShopifySection(event) {
    refresh(event.target);
  });

  document.addEventListener('shopify:section:unload', function destroyShopifySection(event) {
    destroy(event.target);
  });
})();
